import React from "react";
import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 26, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.75, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionLabel = ({ children, num }) => (
  <div className="flex items-center gap-3 mb-5">
    {num && (
      <span className="font-mono-x text-xs text-amber-400">{num}</span>
    )}
    <span className="h-px w-8 bg-amber-400/60" />
    <span className="font-mono-x text-[11px] uppercase tracking-[0.28em] text-amber-400 font-semibold">
      {children}
    </span>
  </div>
);

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -90, duration: 1.1 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};
